<template>
    <PageBase class="content-background-forms">
        <template v-slot:navigation>
            <D4DNavigation />
        </template>
        <router-view></router-view>
    </PageBase>
</template>

<script>
    import PageBase from '../../../core/Components/PageBase.vue'
    import D4DNavigation from '../Components/D4DNavigation.vue'

    export default {
        name: "FormPage",
        components: {PageBase, D4DNavigation}
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .content-background-forms
        background-color color-1

    +for_breakpoint(xs)
        .content-background-forms
            background-image linear-gradient(color-1 0%, color-1 50%, white 60%, white 100%)

</style>